export const getFromLocalStorage = (key: string, defaultValue: string): string =>
    localStorage.getItem(key) ?? defaultValue;

export const setInLocalStorage = (key: string, value: string): void => {
    localStorage.setItem(key, value);
};
